import api from "@/lib/api";

// ---------- CRUD ----------
export const listResumes = () =>
  api.get("/resumes").then((r) => r.data);

export const getResume = (id) =>
  api.get(`/resumes/${id}`).then((r) => r.data);

export const createResume = (payload) =>
  api.post("/resumes", payload).then((r) => r.data);

export const updateResume = (id, payload) =>
  api.put(`/resumes/${id}`, payload).then((r) => r.data);

export const deleteResume = (id) =>
  api.delete(`/resumes/${id}`).then((r) => r.data);

export const duplicateResume = (id) =>
  api.post(`/resumes/${id}/duplicate`).then((r) => r.data);

// ---------- Upload Existing Resume / AI ATS Upgrade ----------
export const uploadResumeForUpgrade = (
  file,
  target_role = ""
) => {
  const form = new FormData();

  form.append("file", file);
  form.append("target_role", target_role || "");

  return api
    .post("/resumes/import", form)
    .then((r) => r.data);
};

// ---------- AI ----------
export const aiGenerateSummary = (payload) =>
  api
    .post("/resumes/ai/summary", payload)
    .then((r) => r.data);

export const aiGenerateBullets = (payload) =>
  api
    .post("/resumes/ai/experience", payload)
    .then((r) => r.data);

export const aiSuggestSkills = (payload) =>
  api
    .post("/resumes/ai/skills", payload)
    .then((r) => r.data);

export const aiImproveText = (
  text,
  kind = "general"
) =>
  api
    .post("/resumes/ai/improve", {
      text,
      kind,
    })
    .then((r) => r.data);

// ---------- ATS / JOB MATCH ----------
export const scoreATS = (id) =>
  api
    .post(`/resumes/${id}/ats-score`)
    .then((r) => r.data);

export const optimizeForJob = (
  id,
  job_description
) =>
  api
    .post(`/resumes/${id}/optimize-job`, {
      job_description,
    })
    .then((r) => r.data);

export const getLatestATS = (id) =>
  api
    .get(`/resumes/${id}/ats-latest`)
    .then((r) => r.data);

export const getResumeHistory = (id) =>
  api
    .get(`/resumes/${id}/history`)
    .then((r) => r.data);

export const getATSTrend = (id) =>
  api
    .get(`/resumes/${id}/ats-trend`)
    .then((r) => r.data);

// ---------- DOCX DOWNLOAD ----------
export const downloadResumeDOCX = (id) =>
  api
    .get(`/resumes/${id}/docx`, {
      responseType: "blob",
    })
    .then((r) => {
      const url = URL.createObjectURL(r.data);

      const a = document.createElement("a");

      a.href = url;
      a.download = "resume.docx";

      document.body.appendChild(a);

      a.click();

      a.remove();

      URL.revokeObjectURL(url);
    });

// ---------- DEFAULT RESUME ----------
export const emptyResumeData = () => ({
  full_name: "",
  email: "",
  phone: "",
  location: "",
  linkedin: "",

  target_role: "",
  industry: "",

  summary: "",

  experience: [],
  education: [],
  skills: [],
  certifications: [],
  projects: [],
  languages: [],
});

// ---------- EMPTY SECTIONS ----------
export const blankExperience = () => ({
  title: "",
  company: "",
  location: "",
  start: "",
  end: "",
  current: false,
  bullets: [],
});

export const blankEducation = () => ({
  degree: "",
  school: "",
  location: "",
  start: "",
  end: "",
  gpa: "",
});

export const blankCertification = () => ({
  name: "",
  issuer: "",
  year: "",
});

export const blankProject = () => ({
  name: "",
  description: "",
  link: "",
  tech: "",
});

export const blankLanguage = () => ({
  name: "",
  level: "Conversational",
});

// ---------- RESUME TEMPLATES ----------
export const TEMPLATE_META = {
  minimal: {
    label: "Minimal ATS",
    accent: "#27272A",
    description: "Ultra-clean · safest ATS parsing",
    tier: "free",
  },

  modern: {
    label: "Modern Professional",
    accent: "#2563EB",
    description: "Polished blue · recruiter-friendly",
    tier: "free",
  },

  engineering: {
    label: "Engineering Pro",
    accent: "#0891B2",
    description: "Technical-first · strong hierarchy",
    tier: "free",
  },

  executive: {
    label: "Executive Classic",
    accent: "#1E293B",
    description: "Leadership · elegant and conservative",
    tier: "free",
  },

  graduate: {
    label: "Graduate Launch",
    accent: "#059669",
    description: "Education + projects · early career",
    tier: "free",
  },

  swiss: {
    label: "Swiss Editorial",
    accent: "#DC2626",
    description: "Crisp editorial typography",
    tier: "premium",
  },

  consulting: {
    label: "Consulting",
    accent: "#7C3AED",
    description: "Dense · achievement-focused",
    tier: "premium",
  },

  elegant: {
    label: "Elegant Serif",
    accent: "#7C5A36",
    description: "Premium serif · finance & leadership",
    tier: "premium",
  },

  tech: {
    label: "Tech Impact",
    accent: "#0F766E",
    description: "Modern technical · skills-forward",
    tier: "premium",
  },

  creative: {
    label: "Creative ATS",
    accent: "#DB2777",
    description: "Distinctive · still single-column",
    tier: "premium",
  },
};
